import { fr } from "../../../../date-fns/locale/fr.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    fr
  }
};